import { useEffect } from "react";

import { Messages } from "@zapier/held-runs-embed/src/types";

import { sendMessageToParent } from "../utils/iframeUtils/iframeUtils";

export function useIFrameResize(additionalHeight = 0) {
  useEffect(() => {
    const { scrollHeight } = document.documentElement;
    const height = `${scrollHeight + additionalHeight}px`;
    sendMessageToParent({
      height,
      type: Messages.sizeChange,
    });
  });
}
